<div class="sales-dashboard">
    <!-- <div class="dashboard-header">
      <h2>Sales Performance Dashboard</h2>
      <div class="toggle-container" *ngIf="viewOption === 'toggle'">
        <label class="toggle-label">
          <nb-toggle 
            [(ngModel)]="showCumulative" 
            (ngModelChange)="onToggleChange()">
          </nb-toggle>
          <span class="toggle-text">{{ showCumulative ? 'Cumulative View' : 'Period View' }}</span>
        </label>
      </div>
      <div class="mode-indicator" *ngIf="viewOption !== 'toggle'">
        <span class="indicator-text">{{ getModeLabel() }}</span>
      </div>
    </div> -->
    
    <nb-tabset>
      <nb-tab tabTitle="Week" tabIcon="calendar-outline">
        <div class="chart-container" *ngIf="shouldShowChart()">
          <h6>{{ getCurrentWeekRange() }} - {{ showCumulative ? 'Cumulative' : 'Daily' }}</h6>
          <div id="weekChart" class="chart"></div>
        </div>
        <div class="totals-container" *ngIf="shouldShowTotals()">
          <h6>{{ getCurrentWeekRange() }}</h6>
          <div class="totals-content">
            <div class="total-card">
              <h6>Total Sales</h6>
              <p class="total-amount">{{ weekTotal | currency}}</p>
            </div>
            <!-- <div class="breakdown">
              <h5>Daily Breakdown</h5>
              <div class="breakdown-list">
                <div *ngFor="let item of generateWeekData()" class="breakdown-item">
                  <span class="breakdown-date">{{ item.date }}</span>
                  <span class="breakdown-amount">\${{ item.sales.toLocaleString() }}</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </nb-tab>
      
      <nb-tab tabTitle="Month" tabIcon="trending-up-outline">
        <div class="chart-container" *ngIf="shouldShowChart()">
          <h6>Current Month Sales ({{ getCurrentMonthName() }}) - {{ showCumulative ? 'Cumulative' : 'Daily' }}</h6>
          <div id="monthChart" class="chart"></div>
        </div>
        <div class="totals-container" *ngIf="shouldShowTotals()">
          <h6>{{ getCurrentMonthName() }}</h6>
          <div class="totals-content">
            <div class="total-card">
              <h5>Total Sales</h5>
              <p class="total-amount">{{ monthTotal | currency }}</p>
            </div>
            <!-- <div class="summary-stats">
              <div class="stat-item">
                <span class="stat-label">Days with Data:</span>
                <span class="stat-value">{{ generateMonthData().length }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Average Daily:</span>
                <span class="stat-value">\${{ getMonthAverage().toLocaleString() }}</span>
              </div>
            </div> -->
          </div>
        </div>
      </nb-tab>
      
      <nb-tab tabTitle="YTD" tabIcon="bar-chart-outline">
        <div class="chart-container" *ngIf="shouldShowChart()">
          <h6>{{ getCurrentYear() }} - {{ showCumulative ? 'Cumulative' : 'Period' }}</h6>
          <div id="ytdChart" class="chart"></div>
        </div>
        <div class="totals-container" *ngIf="shouldShowTotals()">
          <h6>{{ getCurrentYear() }}</h6>
          <div class="totals-content">
            <div class="total-card">
              <h5>Total YTD Sales</h5>
              <p class="total-amount">{{ ytdTotal | currency}}</p>
            </div>
            <!-- <div class="summary-stats">
              <div class="stat-item">
                <span class="stat-label">Data Points:</span>
                <span class="stat-value">{{ generateYTDData().length }}</span>
              </div>
              <div class="stat-item">
                <span class="stat-label">Months Completed:</span>
                <span class="stat-value">{{ getCurrentMonth() + 1 }}</span>
              </div>
            </div> -->
          </div>
        </div>
      </nb-tab>
    </nb-tabset>
  </div>
